import { getHostname, getWebAppHostname } from "./hostname";

/**
 * @deprecated genAbsoluteURL returns the absolute URL of the current hostname.
 * This is unreliable if your component can be used in multiple domains. Please
 * use the correct genWebAppURL or genURLThisDomain instead.
 *
 * This is deprecated to force us to audit existing usage and use the more explicit version.
 */
export function genAbsoluteURL(path: string): string {
  return new URL(path, getHostname()).href;
}

/**
 * Generates a URL for the web app, ie.. https://punchup.live/[path]
 */
export function genWebAppURL(path: string): string {
  return new URL(path, getWebAppHostname()).href;
}

/**
 * Generates a URL for the current domain.
 * This is useful for components that can be used in multiple domains to point
 * to the same domain the component is being used on.
 */
export function genURLThisDomain(path: string): string {
  return new URL(path, getHostname()).href;
}
